// extracted by mini-css-extract-plugin
module.exports = {"title":"title-module--title--3cwhp","smaller":"title-module--smaller--2-lXo"};